/*const loginUrl = "http://localhost:8000/api/login";
const registerUrl = "http://localhost:8000/api/register"
const logoutUrl = "http://localhost:8000/api/logout"
const usersUrl = "http://localhost:8000/api/user-by-state/all/5000"
const mailUrl = "http://localhost:8000/api/mail";
const userByMailUrl = "http://localhost:8000/api/check-user-by-email";
const staticUrl = "http://localhost:8000";
const uploadUrl = "http://localhost:8000/api";
const updateUserUrl = "http://localhost:8000/api/update-user-info"

*/
const APP = "https://sesame.fintechgodwin.com"
const loginUrl = APP+"/api/login";
const registerUrl = APP+"/api/register"
const logoutUrl = APP+"/api/logout"
const usersUrl = APP+"/api/user-by-state/all/5000"
const mailUrl = APP+"/api/mail";
const userByMailUrl = APP+"/api/check-user-by-email";
const staticUrl = APP+"/public";
const uploadUrl = APP+"/api";
const updateUserUrl = APP+"/api/update-user-info"

export {loginUrl, registerUrl, logoutUrl, usersUrl, mailUrl, userByMailUrl, staticUrl, updateUserUrl, uploadUrl}
